(function () {
  function initBuyBox(box) {
    var radios = box.querySelectorAll('[data-npb-radio]');
    var headlinePrice = box.querySelector('.novera-buybox__headline-price');
    var headlineSuffix = box.querySelector('.novera-buybox__headline-suffix');
    var sellingPlanInput = box.querySelector('input[name="selling_plan"]');
    var quantityInput = box.querySelector('input[name="quantity"]');

    // This buy box lives in the product info column, structurally OUTSIDE
    // the actual <form>, which is why its hidden inputs are bound to it via
    // the `form="..."` attribute rather than DOM nesting. To find the real
    // form (for the foreign-widget cleanup below) we have to resolve that
    // same attribute rather than walk up the DOM with closest('form').
    var formId = sellingPlanInput && sellingPlanInput.getAttribute('form');
    var form = formId ? document.getElementById(formId) : null;

    var suffixMap = {
      subscribe: 'with subscription',
      three: 'per bottle · 3-bottle pack',
      single: 'one-time purchase'
    };

    function applySelection(radio) {
      var option = radio.closest('[data-npb-option]');
      if (!option) return;

      box.querySelectorAll('[data-npb-option]').forEach(function (el) {
        el.classList.remove('is-selected');
      });
      option.classList.add('is-selected');

      var priceNow = option.querySelector('.novera-buybox__price-now');
      if (priceNow && headlinePrice) {
        headlinePrice.textContent = priceNow.textContent.trim();
      }
      if (headlineSuffix) {
        headlineSuffix.textContent = suffixMap[radio.value] || '';
      }

      if (quantityInput) {
        quantityInput.value = radio.getAttribute('data-quantity') || '1';
      }

      if (sellingPlanInput) {
        var plan = radio.getAttribute('data-selling-plan');
        if (plan) {
          sellingPlanInput.value = plan;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        applySelection(radio);
      });
    });

    var checked = box.querySelector('[data-npb-radio]:checked');
    if (checked) applySelection(checked);

    /**
     * Third-party apps (e.g. Seal Subscriptions) inject their own purchase-option
     * widget directly inside the same <form>, including their own hidden
     * `selling_plan` / `quantity` inputs. Because those inputs share the same
     * `name` as the ones this buy box controls, a plain form submit would send
     * BOTH values and let the browser/server pick one arbitrarily — silently
     * breaking whichever option the shopper actually chose here.
     *
     * To keep this buy box as the single source of truth we: (1) hide any
     * such third-party widget visually, and (2) disable its inputs so they
     * are excluded from form submission entirely. This runs immediately and
     * also watches the form for widgets that render asynchronously.
     */
    function neutralizeForeignInput(el) {
      if (!el || el === sellingPlanInput || el === quantityInput) return;
      var name = el.getAttribute('name');
      if (name !== 'selling_plan' && name !== 'quantity') return;
      el.disabled = true;
    }

    function hideKnownForeignWidgets(root) {
      var selectors = ['.sealsubs-target-element', '.sealsubs-container'];
      selectors.forEach(function (sel) {
        root.querySelectorAll(sel).forEach(function (el) {
          el.style.display = 'none';
        });
      });
    }

    function scan(root) {
      if (!root || root.nodeType !== 1) return;
      hideKnownForeignWidgets(root.querySelectorAll ? root : document);
      var candidates = root.querySelectorAll
        ? root.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"], input[name="quantity"], select[name="quantity"]')
        : [];
      candidates.forEach(neutralizeForeignInput);
      if (root.matches && root.matches('input[name="selling_plan"], select[name="selling_plan"], input[name="quantity"], select[name="quantity"]')) {
        neutralizeForeignInput(root);
      }
    }

    if (form) {
      scan(form);

      if (window.MutationObserver) {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              scan(node);
            });
          });
        });
        observer.observe(form, { childList: true, subtree: true });
      }
    }
  }

  function init() {
    document.querySelectorAll('.novera-buybox').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
